# `modal setup`

Bootstrap Modal's configuration.

**Usage**:

```shell
modal setup [OPTIONS]
```

**Options**:

* `--profile TEXT`
* `--help`: Show this message and exit.

